import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonIcon from '@/components/atoms/ButtonIcon';
import clsx from 'clsx';
import { useState } from 'react';
const FooterAccordion = ({ title, isOpen, children }) => {
    const [open, setOpen] = useState(isOpen);
    const toggleAccordion = () => {
        setOpen(!open);
    };
    return (_jsxs("div", { className: "flex flex-col gap-1", children: [_jsxs("button", { onClick: toggleAccordion, className: "type-feature-body flex w-full items-center justify-between text-left lg:justify-start lg:gap-0.75", children: [title, _jsx(ButtonIcon, { variant: open ? 'chevron-up' : 'chevron-down' })] }), _jsx("div", { inert: open ? undefined : '', className: clsx(!open && 'hidden lg:invisible lg:block'), children: children })] }));
};
export default FooterAccordion;
